import { CellClassParams, ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { FieldErrors } from 'react-hook-form';

import { IBomPart } from 'bom/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { NumberHelper } from 'core/helpers';

import { ActionsCell, ElementCell, QuantityPerElementCell } from './cells';
import { IManageElementData } from './type';

export const getColumnDefs = (
  errors: FieldErrors<IManageElementData>,
  bomPart: IBomPart
): ColDef[] => {
  return [
    {
      colId: 'line',
      headerName: '#',
      pinned: 'left',
      field: 'line',
      wrapText: false,
      suppressPaste: true,
      suppressFillHandle: true,
      suppressSizeToFit: false,
      suppressHeaderMenuButton: true,
      resizable: false,
      minWidth: 60,
      width: 60,
      maxWidth: 60,
      suppressColumnsToolPanel: true,
      suppressMovable: true,
      floatingFilter: false,
      headerClass: 'paddingSmall',
      cellClass: 'noDecorationCell',
      cellStyle: { fontWeight: 'bold' },
      cellDataType: 'number',
      valueFormatter: ({ value }) => (!value ? '' : value),
      cellRendererParams: { placeholder: '' },
    },
    {
      colId: 'element',
      headerName: t('headerElement'),
      field: 'element',
      cellClass: ({ rowIndex }: CellClassParams) => {
        if (errors && errors[rowIndex] && errors[rowIndex].element) {
          return 'dangerBackground';
        }

        return '';
      },
      valueFormatter: ({ value }) => value?.name,
      cellRenderer: ElementCell,
      cellRendererParams: { jobId: bomPart.bomId },
      flex: 4,
    },
    {
      colId: 'quantity',
      headerName: t('headerElementQuantity'),
      field: 'quantity',
      cellDataType: 'number',
      valueFormatter: ({ value }) => quantityFormatter(value),
      cellStyle: { textAlign: 'right' },
      flex: 2,
    },
    {
      colId: 'quantityPerElement',
      headerName: t('headerQuantityPerElement'),
      field: 'quantityPerElement',
      cellDataType: 'number',
      cellClass: ({ rowIndex }: CellClassParams) => {
        if (errors && errors[rowIndex] && errors[rowIndex].quantityPerElement) {
          return 'dangerBackground';
        }

        return '';
      },
      cellRenderer: QuantityPerElementCell,
      flex: 2,
    },
    {
      colId: 'uom',
      headerName: t('headerUom'),
      field: 'uom',
      width: 80,
      maxWidth: 80,
      cellDataType: 'text',
      valueGetter: () => bomPart.uom,
    },
    {
      colId: 'totalQuantity',
      headerName: t('headerTotalQuantity'),
      field: 'totalQuantity',
      cellDataType: 'number',
      cellStyle: { textAlign: 'right' },
      valueGetter: ({ data }) => data.quantity * data.quantityPerElement,
      valueFormatter: ({ value }) => quantityFormatter(value),
      flex: 2,
    },
    {
      colId: 'actions',
      width: 40,
      maxWidth: 40,
      pinned: 'right',
      sortable: false,
      resizable: false,
      lockPinned: true,
      suppressColumnsToolPanel: true,
      headerClass: 'paddingSmall',
      cellClass: 'paddingSmall noDecorationCell',
      cellRenderer: ActionsCell,
    },
  ];
};

const quantityFormatter = (value: number | null) =>
  value ? NumberHelper.format({ amount: value }) : DEFAULT_PLACEHOLDER;
